import React, { useMemo } from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Create a consistent cache key for both server and client
const cacheKey = "css";

// Create emotion cache with consistent configuration
const createEmotionCache = () => {
  return createCache({
    key: cacheKey,
    // Ensure consistent styling between server and client
    prepend: true,
    // Disable speedy mode to prevent hydration mismatches
    speedy: false,
  });
};

interface EmotionCacheProviderProps {
  children: React.ReactNode;
}

export const EmotionCacheProvider: React.FC<EmotionCacheProviderProps> = ({ children }) => {
  const cache = useMemo(() => createEmotionCache(), []);

  return <CacheProvider value={cache}>{children}</CacheProvider>;
};

// Export the cache creation function for SSR usage
export { createEmotionCache };
